/**
 * Vue 2/3 compatibility utilities
 * Provides a unified interface for Vue 2 and Vue 3 Composition API
 */

// Dynamic imports will be resolved at runtime
let vueModule: any = null;
let compositionApiModule: any = null;

function getVueModule() {
  if (!vueModule) {
    try {
      vueModule = require("vue");
    } catch (e) {
      throw new Error("Vue is not installed. Please install vue.");
    }
  }
  return vueModule;
}

function getCompositionApiModule() {
  if (!compositionApiModule) {
    try {
      compositionApiModule = require("@vue/composition-api");
    } catch (e) {
      // If @vue/composition-api is not available, use Vue directly (Vue 3)
      compositionApiModule = getVueModule();
    }
  }
  return compositionApiModule;
}

export function getVueCompositionApi() {
  const vue = getVueModule();
  const version = vue.version || "3.0.0";

  // Check if Vue 2
  if (version.startsWith("2.")) {
    return getCompositionApiModule();
  }

  // Vue 3
  return vue;
}

export function isVue2Compatible(): boolean {
  try {
    const vue = getVueModule();
    const version = vue.version || "3.0.0";
    return version.startsWith("2.");
  } catch {
    return false;
  }
}

export function getVueVersion(): 2 | 3 {
  try {
    const vue = getVueModule();
    const version = vue.version || "3.0.0";
    return version.startsWith("2.") ? 2 : 3;
  } catch {
    return 3;
  }
}
